import * as React from "react";
import { LobSubtitleWithLinkProps } from "./typings";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkSubheading } from "uitk-react-text";
import { UitkLink } from "uitk-react-link";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { Action } from "src/components/utility/analytics/FlexAnalyticsUtils";

export const LobSubtitleWithLink = ({ linkUrl, locKey, locLinkKey, className }: LobSubtitleWithLinkProps) => {
  const { formatText } = useLocalization();
  const text = formatText(locKey);
  const linkText = formatText(locLinkKey);

  return (
    <div className={className} data-testid="lobsubtitle">
      <UitkSubheading>
        {text}{" "}
        <UitkLink inline={true}>
          <TrackedLink moduleName="LobSubtitleWithLink" action={Action.CLICK} href={linkUrl} rfrr="subtitle.link">
            {linkText}
          </TrackedLink>
        </UitkLink>
      </UitkSubheading>
    </div>
  );
};
